export default "__VITE_ASSET__BoidzLMZ__"